(() => {
  function initialize() {
    document.querySelectorAll('[data-yz303-gallery]').forEach(root => {
      if (root.dataset.yz303Ready) return;
      root.dataset.yz303Ready = 'true';
      const main = root.querySelector('.csv2-product-gallery__main');
      const slides = Array.from(main.querySelectorAll('[data-slide]'));
      const thumbnails = Array.from(root.querySelectorAll('[data-view]'));
      const dialog = root.querySelector('[data-yz303-dialog]');
      const stage = root.querySelector('[data-yz303-stage]');
      let current = 0, returnFocus = null, ignoreClickUntil = 0;
      function updateViewer() {
        stage.replaceChildren();
        const slide = slides[current];
        const content = slide.hasAttribute('data-yz303-circuit') ? slide.querySelector('.yz303-circuit-frame') : slide.querySelector('img');
        if (content) {
          const copy = content.cloneNode(true);
          copy.querySelectorAll?.('img').forEach(image => {image.loading = 'eager';});
          if (copy instanceof HTMLImageElement) copy.loading = 'eager';
          stage.append(copy);
        }
        root.querySelector('[data-yz303-viewer-status]').textContent = 'Image ' + (current + 1) + ' of ' + slides.length;
      }
      function select(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {slide.hidden = i !== current;});
        thumbnails.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.view) === current)));
        root.querySelector('[data-yz303-status]').textContent = 'Image ' + (current + 1) + ' of ' + slides.length;
        if (dialog.open) updateViewer();
      }
      function openViewer() {
        returnFocus = document.activeElement;
        updateViewer();
        dialog.showModal();
      }
      root.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-view]');
        if (thumbnail) {select(Number(thumbnail.dataset.view)); return;}
        if (event.target.closest('[data-yz303-close]')) {dialog.close(); return;}
        if (event.target.closest('[data-yz303-previous]')) {select(current - 1); return;}
        if (event.target.closest('[data-yz303-next]')) {select(current + 1); return;}
        if (event.target.closest('[data-yz303-open]') || (main.contains(event.target) && performance.now() > ignoreClickUntil)) openViewer();
      });
      root.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          select(current + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      dialog.addEventListener('close', () => {returnFocus?.focus?.({preventScroll: true});});
      function enableSwipe(element) {
        let start = null;
        element.addEventListener('touchstart', event => {
          start = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY, time: performance.now()} : null;
        }, {passive: true});
        element.addEventListener('touchend', event => {
          if (!start || event.changedTouches.length !== 1) return;
          const dx = event.changedTouches[0].clientX - start.x;
          const dy = event.changedTouches[0].clientY - start.y;
          if (performance.now() - start.time < 900 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            select(current + (dx < 0 ? 1 : -1));
            ignoreClickUntil = performance.now() + 450;
          }
          start = null;
        }, {passive: true});
        element.addEventListener('touchcancel', () => {start = null;}, {passive: true});
      }
      enableSwipe(main);
      enableSwipe(stage);
      select(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
